var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronStart = function SvgChevronStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.469 9.467a.747.747 0 0 0 0 1.059l6 6.003a.75.75 0 0 0 1.06-1.06l-5.47-5.471 5.472-5.469a.75.75 0 0 0-1.06-1.06zm12-6-6 6a.747.747 0 0 0 0 1.059l6 6.003a.75.75 0 0 0 1.06-1.06l-5.47-5.468 5.472-5.472a.75.75 0 0 0-1.06-1.06z"
  })));
};
export default SvgChevronStart;